<p>
  templates-detail works!
</p>
